class applicationMenuActionHelper {
    setApplicationMenuAction = (applicationMenuAction) => {
        this.setSchemeNumber(applicationMenuAction.SchemeNumber);
        this.setSchemeExtensionId(applicationMenuAction.SchemeExtensionId);
        this.setCurrentMenuAction(applicationMenuAction.CurrentMenuAction);
    }

    setSchemeNumber = (schemeNumber) => {
        localStorage.setItem("schemeNumber", schemeNumber);
    }

    getSchemeNumber = () => {
        return localStorage.getItem("schemeNumber")?? 0;
    }

    setSchemeExtensionId = (schemeExtensionId) => {
        localStorage.setItem("schemeExtensionId", schemeExtensionId);
    }

    getSchemeExtensionId = () => {
        return localStorage.getItem("schemeExtensionId")?? 0;
    }

    setCurrentMenuAction = (currentMenuAction) => {
        localStorage.setItem("currentMenuAction", currentMenuAction);
    }

    getCurrentMenuAction = () => {
        return localStorage.getItem("currentMenuAction")?? "";
    }

    deleteApplicationMenuAction = () => {
        localStorage.removeItem("schemeNumber");
        localStorage.removeItem("schemeExtensionId");
        localStorage.removeItem("currentMenuAction");
    }
}

const ApplicationMenuActionHelperSingleton = new applicationMenuActionHelper();
export default ApplicationMenuActionHelperSingleton;